import { apiFetch } from "./client";

export const submitContactForm = (payload) =>
  apiFetch("/enduser/contact-us/", {
    method: "POST",
    body: payload,
  });
